module.exports = __webpack_public_path__ + "img/hudson_valley_lighting.ce5c208.png";